import { render, staticRenderFns } from "./Ezpay.vue?vue&type=template&id=7874f969&"
import script from "./Ezpay.vue?vue&type=script&lang=js&"
export * from "./Ezpay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports